export default __webpack_public_path__ + "static/TradeGothicLTStd-7ab878694366bfa2132c8e81334141ea.woff";